import _ from 'lodash';

import api from 'mixins/api';

export default {
  mixins: [
    api
  ],
  data () {
    return {
      saving: false
    };
  },
  methods: {
    save () {
      let data = Object.assign({}, this.details),
        request;

      data.requisites = JSON.stringify(data.requisites);
      this.saving = true;
      
      if (this.details.id) {
        request = this.api.put(`/payment-details/${this.details.id}`, data);
      } else {
        request = this.api.post(`/service-providers/${this.provider.id}/payment-details`, data);
      }

      request.then(response => {
        this.$q.notify({
          message: 'Сохранено',
          type: 'positive'
        });
        this.$emit('update:details', response.data);
        this.saving = false;
      }).catch(error => {
        let errorMessage = error.response.data.error;
        if (errorMessage) {
          this.$q.notify({message: errorMessage, type: 'negative'});
        }
        
        _.forOwn(error.response.data.errors, (value, key) => {
          this.$q.notify({message: value[0], type: 'negative'});
        });
        this.saving = false;
      });
      
      
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/PaymentMethodEdit/methods/mixins/harvester.js